import { FC } from 'react';

interface IPlusCircleIconProps {
  stroke?: string;
}

const PlusCircleIcon: FC<IPlusCircleIconProps> = (props) => {
  const { stroke } = props;
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      stroke={stroke ?? 'none'}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5001 6.66602V13.3327M7.16675 9.99935H13.8334M18.8334 9.99935C18.8334 14.6017 15.1025 18.3327 10.5001 18.3327C5.89771 18.3327 2.16675 14.6017 2.16675 9.99935C2.16675 5.39698 5.89771 1.66602 10.5001 1.66602C15.1025 1.66602 18.8334 5.39698 18.8334 9.99935Z"
        stroke={stroke ?? '#667085'}
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PlusCircleIcon;
